import { useEffect } from 'react';
import { ThemeProvider } from '@cbhq/cds-web/system';

import { palette } from ':cloud/widgets/buildQuest/assets/colors';
import { BuildQuestGameBoard } from ':cloud/widgets/buildQuest/BuildQuestGameBoard';
import { BuildQuestHelmet } from ':cloud/widgets/buildQuest/BuildQuestHelmet';
import { BuildQuestNavigation } from ':cloud/widgets/buildQuest/BuildQuestNavigation';
import { BuildQuestProvider } from ':cloud/widgets/buildQuest/BuildQuestProvider';
import { BuildQuestPrizes } from ':cloud/widgets/buildQuest/PrizesModal';
import { ZoomableProvider } from ':cloud/widgets/buildQuest/SimpleZoomable';
import { CloudErrorBoundary } from ':cloud/widgets/sharedcomponents/CloudErrorBoundary';

export function BuildQuestLanding(): React.ReactElement {
  const bodyElement = document.body;
  bodyElement.style.backgroundColor = 'rgb(10,11,13)'; // we don't have access to the theme provider here

  // for each color in palette, set the CSS variable so we can use 'em in linaria
  Object.entries(palette).forEach(([key, value]) => {
    bodyElement.style.setProperty(`--${key}`, value);
  });

  // hide the env banner
  const envBanner = document.querySelector('[data-testid="banner"]');
  if (envBanner instanceof HTMLElement) {
    envBanner.style.display = 'none';
  }

  useEffect(() => {
    const style = [
      'background: linear-gradient(90deg, #8000ff, #0047ff, #ff57c6, #6100ff)',
      'color: white',
      'font-size: 14px',
      'font-weight: bold',
      'padding: 10px',
      'border-radius: 4px',
    ].join(';');

    const asciiArt = `
    ██████╗██████╗ ██████╗      ██████╗ ██╗   ██╗███████╗███████╗████████╗
   ██╔════╝██╔══██╗██╔══██╗    ██╔═══██╗██║   ██║██╔════╝██╔════╝╚══██╔══╝
   ██║     ██║  ██║██████╔╝    ██║   ██║██║   ██║█████╗  ███████╗   ██║
   ██║     ██║  ██║██╔═══╝     ██║▄▄ ██║██║   ██║██╔══╝  ╚════██║   ██║
   ╚██████╗██████╔╝██║         ╚██████╔╝╚██████╔╝███████╗███████║   ██║
    ╚═════╝╚═════╝ ╚═╝          ╚══▀▀═╝  ╚═════╝ ╚══════╝╚══════╝   ╚═╝   `;

    // eslint-disable-next-line no-console
    console.log(asciiArt);
    // eslint-disable-next-line no-console
    console.log(
      '%cCoinbase Developer Platform (CDP) is building tools to bring the world onchain.',
      style,
    );
    // eslint-disable-next-line no-console
    console.log(
      "%c🚀 We're hiring! %chttps://www.coinbase.com/careers/positions/developer-platform",
      'font-size: 14px; font-weight: bold; color: #0052FF;',
      'font-size: 14px; color: #1B53E4; text-decoration: underline;',
    );
  }, []);

  return (
    <ThemeProvider scale="large" spectrum="dark">
      <BuildQuestHelmet />
      <CloudErrorBoundary name="BuildQuestLanding">
        <BuildQuestProvider>
          <ZoomableProvider>
            <BuildQuestNavigation />
            <BuildQuestGameBoard />
            <BuildQuestPrizes />
          </ZoomableProvider>
        </BuildQuestProvider>
      </CloudErrorBoundary>
    </ThemeProvider>
  );
}
